import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import styles from './ManageAccount.module.css'

const ManageAccount = () => {
    const navigate = useNavigate()
    return (
        <div className={styles.manageAccountContainer}>
            <h1>Account Manager</h1><br />
            <h2>Edit account settings or change password.</h2>
            <div className={styles.manageAccountContainer}>
                <Link to={`/ManageProfile`} className={styles.eventLinks} title="Change profile settings.">
                    <h3>Manage Profile</h3>
                </Link>
                <Link to={`/ChangePassword`} className={styles.eventLinks} title="Change password.">
                    <h3>Change Password</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default ManageAccount;
